import { WORKFLOW_STATUS } from "@circle-workflows/constants";

export const isWorkflowActiveOrInProgress = (workflowStatus?: string) =>
  workflowStatus === WORKFLOW_STATUS.IN_PROGRESS ||
  workflowStatus === WORKFLOW_STATUS.ACTIVE;
